import moment from 'moment';

export const getTimeEntryDuration = ({ start, end = new Date() }) => new Date(end) - new Date(start);

export const getTimeEntriesDuration = timeEntries => timeEntries.reduce((totalDuration, timeEntry) => totalDuration + getTimeEntryDuration(timeEntry), 0);

export const getFormattedDuration = input => {
      const ms = input % 1000;
      input = (input - ms) / 1000;
      const secs = input % 60;
      input = (input - secs) / 60;
      const mins = input % 60;
      const hrs = (input - mins) / 60;

      return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

export const groupTimeEntries = (timeEntries, groupBy) => timeEntries.reduce((groups, timeEntry) => {
    const id = groupBy === 'start' ? moment(timeEntry[groupBy]).startOf('day').valueOf() : timeEntry[groupBy]

    if (!groups.some(group => group.id === id)) {
        // Create group
        groups.push({
            id,
            items: [],
            totalDuration: 0
        });
    }

    const group = groups.find(group => group.id === id);

    group.items.push(timeEntry);
    group.totalDuration += getTimeEntryDuration(timeEntry);

    return groups;
}, []);

export const getTimeEntriesByTaskId = (timeEntries, taskId) => (timeEntries || [])
    .filter(timeEntry => timeEntry.task === taskId)
    .sort((t1, t2) => new Date(t2.start) - new Date(t1.start));
